import { useQuery } from '@tanstack/react-query'
import React from 'react'

import { type BrandAccount } from './useMainQuery'
import { useMainQueryKey } from './useMainQueryKey'

const defaultSeat = {
  __typename: 'Seat' as const,
  total: 0,
  used: 0,
}

export const useMainQueryBrandAccountSeat = () => {
  const queryKey = useMainQueryKey()
  const { data } = useQuery<BrandAccount>({ enabled: false, queryKey })

  return React.useMemo(() => {
    const partnerSeat = data?.partnerSeat ?? defaultSeat
    const userSeat = data?.userSeat ?? defaultSeat

    return {
      partnerSeat,
      userSeat,
    }
  }, [data?.partnerSeat, data?.userSeat])
}
